import { Form, Formik } from 'formik'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Box, Typography, useTheme } from '@mui/material'
import { useOrder } from 'hooks/useOrders'
import Input from 'components/Input/Input'
import LoadingIndicator from 'components/LoadingIndicator/LoadingIndicator'

export const OrderInfo = () => {
  const { t } = useTranslation()
  const { orderId } = useParams()
  const { error, order } = useOrder(orderId as string)

  const theme = useTheme()

  const initValues = {
    customerId: order.customerInfo.customerId,
    name: order.customerAddress.name,
    email: order.customerAddress.email,
    phone: order.customerAddress.phone,
    loyaltyCardId: order.customerInfo.loyaltyCardId,
    paymentType: t(`orderPayment.${order.payment.type}`),
  }

  if (!order) return <LoadingIndicator />
  if (error) return <h1>Error</h1>
  return (
    <Formik initialValues={initValues} onSubmit={() => undefined}>
      <Form>
        {order && (
          <Box
            display='flex'
            flexDirection='column'
            justifyContent='space-around'
            mt={theme.spacing(3)}>
            <Typography
              variant='body2'
              sx={{
                marginBottom: theme.spacing(4),
                marginTop: 0,
              }}>
              {t('orderInfo.customer')}
            </Typography>
            <Input
              disabled
              marginBottom={theme.spacing(4)}
              label={t('orderInfo.customerId')}
              name='customerId'
              type='text'
              variant='filled'
              fullWidth
            />
            <Input
              disabled
              marginBottom={theme.spacing(4)}
              label={t('name')}
              name='name'
              type='text'
              variant='filled'
              fullWidth
            />
            <Input
              disabled
              marginBottom={theme.spacing(4)}
              label={t('orderInfo.email')}
              name='email'
              type='text'
              variant='filled'
              fullWidth
            />
            <Input
              disabled
              marginBottom={theme.spacing(4)}
              label={t('orderInfo.phone')}
              name='phone'
              type='text'
              variant='filled'
              fullWidth
            />
            <Input
              disabled
              label={t('loyaltyCardNumber')}
              name='loyaltyCardId'
              type='text'
              variant='filled'
              fullWidth
            />
            <Typography
              variant='body2'
              sx={{
                marginBottom: theme.spacing(4),
                marginTop: 0,
              }}>
              {t('payment')}
            </Typography>
            <Input
              disabled
              marginBottom={theme.spacing(4)}
              label={t('orderInfo.paymentType')}
              name='paymentType'
              type='text'
              variant='filled'
            />
          </Box>
        )}
      </Form>
    </Formik>
  )
}
